import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * En-tête des sous-pages de l'app (Concurrents, Page client, Compte…).
 *
 * La barre d'onglets est limitée à 5 entrées — c'est la recommandation d'Apple
 * et au-delà les libellés deviennent illisibles. Les écrans supplémentaires
 * sont donc atteints depuis le Profil, et ont besoin d'un retour explicite :
 * sur iOS il n'existe pas de bouton « précédent » système comme sur Android.
 */
export default function SubPageHeader({ title, subtitle, backTo = '/m/profil' }) {
  const navigate = useNavigate();
  return (
    <header style={styles.wrap}>
      <button
        type="button"
        onClick={() => navigate(backTo)}
        style={styles.back}
        aria-label="Retour"
      >
        ‹
      </button>
      <div style={styles.texts}>
        <h1 style={styles.title}>{title}</h1>
        {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      </div>
    </header>
  );
}

const styles = {
  wrap: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    padding: '4px 0 14px',
  },
  back: {
    // 40 px : en dessous, la cible devient difficile à atteindre au pouce.
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: 12,
    border: '1px solid rgba(0,0,0,0.10)',
    background: '#FFFFFF',
    fontSize: 26,
    lineHeight: 1,
    color: '#1A1A1A',
    cursor: 'pointer',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 3,
  },
  texts: { flex: 1, minWidth: 0 },
  title: { margin: '4px 0 2px', fontSize: 20, fontWeight: 800, color: '#1A1A1A' },
  subtitle: { margin: 0, fontSize: 13, lineHeight: 1.5, color: '#6B6B6B' },
};
